import { axiosProvider, unwrapResponseData } from '@/app/core/axios';
import {
  AvailableAscendQuestLookupsApiResponse,
  DeprecatedAscendQuestLookupsApiResponse,
} from '@ssar-app/domain';
import ms from 'ms';

const cacheTtl = ms('1 week');

export const getAvailableLookupsForProgram = async (
  programId: string,
): Promise<AvailableAscendQuestLookupsApiResponse> => {
  return axiosProvider.apiClient
    .get<AvailableAscendQuestLookupsApiResponse>(
      `/program/quest/available-lookups-for/program-${encodeURIComponent(
        programId,
      )}`,
      {
        cache: {
          ttl: cacheTtl,
        },
      },
    )
    .then(unwrapResponseData);
};

export const getAvailableLookupsForVersionAndSubcode = async (
  version: string,
  subCode: string,
): Promise<AvailableAscendQuestLookupsApiResponse> => {
  return axiosProvider.apiClient
    .get<AvailableAscendQuestLookupsApiResponse>(
      `/program/quest/available-lookups-for/version-${encodeURIComponent(
        version,
      )}/subcode-${encodeURIComponent(subCode)}`,
      {
        cache: {
          ttl: cacheTtl,
        },
      },
    )
    .then(unwrapResponseData);
};

export const getAvailableLookupsForLatestVersionAndSubcode = async (
  subCode: string,
): Promise<AvailableAscendQuestLookupsApiResponse> => {
  return getAvailableLookupsForVersionAndSubcode('latest', subCode);
};

export const getDeprecatedLookupsForProgram = async (
  programId: string,
): Promise<DeprecatedAscendQuestLookupsApiResponse> => {
  return axiosProvider.apiClient
    .get<DeprecatedAscendQuestLookupsApiResponse>(
      `/program/quest/deprecated-lookups-for/program-${encodeURIComponent(
        programId,
      )}`,
      {
        cache: {
          ttl: cacheTtl,
        },
      },
    )
    .then(unwrapResponseData);
};
